import React from 'react';
import ContactFormSection from '../components/ContactFormSection';

const services = [
  {
    title: 'Private Lessons',
    description:
      'One-to-one chess instruction for beginners, developing players and students who benefit from focused, structured guidance.',
    points: [
      'Professional instruction from beginner to advanced level.',
      'Personalized support to strengthen understanding, confidence and quality of play.',
      'Suitable for students learning the game or improving for local and international competition.',
    ],
  },
  {
    title: 'Scholastic Programs',
    description:
      'Structured school-based chess programming for elementary and high schools, designed for group instruction under an organized curriculum, often as an after-school offering.',
    points: [
      'Designed for schools seeking a meaningful educational enrichment programme.',
      'Group lessons that support discipline, concentration and long-term skill development.',
      'A structured format for schools that want students to engage with chess consistently and purposefully.',
    ],
  },
];

const benefits = [
  {
    title: 'Critical Thinking',
    text: 'Chess helps students develop stronger critical thinking, analysis and decision-making skills.',
  },
  {
    title: 'Mathematics and Logic',
    text: 'Chess supports mathematical thinking, logic and efficient problem-solving.',
  },
  {
    title: 'Cognition and Verbal Skills',
    text: 'Chess contributes to cognitive development while also strengthening verbal skills.',
  },
];

const contactImage =
  'https://img.freepik.com/premium-photo/classic-chess-board-transparent-background_971989-23533.jpg';

function LessonsAndProgramsPage() {
  return (
    <div className="page-stack">
      <section className="hero-grid hero-grid-lessons hero-grid-lessons-simple lessons-hero-contained">
        <div className="hero-copy lessons-hero-copy">
          <div className="eyebrow">Lessons and Programs</div>
          <h1 className="lessons-title-decor">
            Private Lessons and
            <br />
            Scholastic Programs
          </h1>
          <p className="hero-text">
            The Bahamas Chess Institute provides professional chess instruction through private
            lessons and school-based scholastic programs led by FIDE Master Cecil Moncur.
            Whether a family is seeking individual instruction or a school is exploring a
            structured chess offering, the Institute provides a credible pathway for chess
            development in The Bahamas.
          </p>

          <div className="inline-note-row inline-note-row-three">
            <div className="inline-note">
              <span className="inline-note-label">Led by</span>
              <strong>FM Cecil Moncur</strong>
            </div>
            <div className="inline-note">
              <span className="inline-note-label">Levels</span>
              <strong>Beginner to advanced</strong>
            </div>
            <div className="inline-note">
              <span className="inline-note-label">Pricing</span>
              <strong>Available on request</strong>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="section-heading">
          <div className="eyebrow">Our Services</div>
          <h3>Two ways to work with the Institute.</h3>
          <p>
            Families can enquire about private lessons for individual students. Schools can
            enquire about structured scholastic chess programs delivered in an organized group
            setting.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <article key={service.title} className="surface-card info-card service-card service-card-polished">
              <div>
                <h4>{service.title}</h4>
                <p>{service.description}</p>

                <ul className="clean-list service-list">
                  {service.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>

              <div className="button-row service-card-actions">
                <a
                  className="primary-btn"
                  href={`mailto:bahamaschessinstitute@gmail.com?subject=${encodeURIComponent(
                    `${service.title} Enquiry`,
                  )}`}
                >
                  Enquire Now
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="content-section">
        <div className="section-heading section-heading-center benefits-heading">
          <div className="eyebrow">Educational Value</div>
          <h3>Why Parents and Schools Choose Chess</h3>
          <p>
            Chess supports academic and personal development in ways that extend beyond the board.
          </p>
        </div>

        <div className="card-grid three-up">
          {benefits.map((benefit) => (
            <article key={benefit.title} className="surface-card info-card benefit-card compact-card">
              <h4>{benefit.title}</h4>
              <p>{benefit.text}</p>
            </article>
          ))}
        </div>
      </section>

      <ContactFormSection
        title="Request lessons, school programs, pricing or availability."
        description="Complete the form and your email app will open with your details pre-filled to send directly to The Bahamas Chess Institute."
        subjectPrefix="Lessons and Programs Enquiry"
        enquiryOptions={['Private Lessons', 'Scholastic Programs', 'General Enquiry']}
        imageSrc={contactImage}
        imageAlt="Chess board visual"
      />
    </div>
  );
}

export default LessonsAndProgramsPage;
